import { render, staticRenderFns } from "./AddDesignation.vue?vue&type=template&id=62292446&"
import script from "./AddDesignation.vue?vue&type=script&lang=js&"
export * from "./AddDesignation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports